import React, { useState } from 'react';
import PinIcon from 'mdi-react/PinIcon';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';

// Votes before the viewer's own
const START_VOTES = { home: 46, draw: 9, away: 7 };

/**
 * A chat in the app, clickable: a pinned post from the club with a poll
 * (vote to see the result), fans' messages with reactions, and a banned
 * word shown as stars. Example content.
 */
const ChatPreview = () => {
  const s = partial('shared');
  const config = useConfig();
  const clubName = config?.club_name || 'Club';
  const [vote, setVote] = useState(null);
  const votes = {
    ...START_VOTES,
    ...(vote && { [vote]: START_VOTES[vote] + 1 }),
  };
  const total = Object.values(votes).reduce((sum, count) => sum + count, 0);

  return (
    <div className="tier-phone chat-preview">
      <div className="heart-preview__head">
        <span aria-hidden>‹</span>
        {s('chatPreviewRoom')}
      </div>
      <div className="chat-preview__body">
        {/* The club's pinned post with a poll */}
        <div className="chat-preview__pinned">
          <span className="chat-preview__pin">
            <PinIcon size={13} />
            {s('chatPreviewPinned')}
          </span>
          <strong>{clubName}</strong>
          <span>{s('chatPreviewQuestion')}</span>
          <div className="chat-preview__poll">
            {['home', 'draw', 'away'].map((option) => {
              const percent = Math.round((votes[option] / total) * 100);
              return (
                <button
                  key={option}
                  type="button"
                  className={`chat-preview__option${
                    vote === option ? ' chat-preview__option--on' : ''
                  }`}
                  aria-pressed={vote === option}
                  onClick={() => setVote(option)}
                >
                  {vote && (
                    <span
                      className="chat-preview__fill"
                      style={{ width: `${percent}%` }}
                      aria-hidden
                    />
                  )}
                  <span className="chat-preview__label">
                    {s(`chatPreviewOption-${option}`)}
                  </span>
                  {vote && <b>{percent}%</b>}
                </button>
              );
            })}
          </div>
          <span className="chat-preview__votes">
            {vote
              ? s('chatPreviewVotes', { count: total })
              : s('chatPreviewVoteHint')}
          </span>
        </div>

        {/* Fans' messages */}
        <div className="chat-preview__msg">
          <span className="chat-preview__avatar">L</span>
          <span>
            <b>Lisa</b>
            {s('chatPreviewMessage1')}
            <span className="chat-preview__reactions">♥ 12</span>
          </span>
        </div>
        <div className="chat-preview__msg">
          <span className="chat-preview__avatar">M</span>
          <span>
            <b>Marcus</b>
            {s('chatPreviewMessage2')}
          </span>
        </div>
        <div className="chat-preview__msg chat-preview__msg--own">
          <span>{s('chatPreviewMessage3')}</span>
        </div>
      </div>
    </div>
  );
};

export default ChatPreview;
